import { useCallback } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";

import { useGetShipmentInvoices } from "api/queries/invoice/useGetShipmentInvoices";
import Textarea from "components/atoms/Textarea/Textarea";
import Alert from "components/molecules/Alert/Alert";

const currentInvoiceSelector = (data: any, currentInvoiceId: string) =>
  data.results.find((invoice: any) => invoice.invoice_id === currentInvoiceId);

function InvoiceFormRemarks() {
  const intl = useIntl();
  const { id: shipmentId } = useParams();
  const [searchParams] = useSearchParams();
  const currentInvoiceId = searchParams.get("invoice");

  const { data: currentInvoice }: any = useGetShipmentInvoices({
    shipmentId: shipmentId!,
    options: {
      select: useCallback((data: any) => currentInvoiceSelector(data, currentInvoiceId!), [currentInvoiceId]),
      refetchOnMount: false,
    },
  });
  return (
    <div>
      <h4 className={currentInvoice?.invoice_type === "additional_invoice" ? "required" : ""}>
        <FormattedMessage id="invoices.remarks" defaultMessage="Remarks" />
      </h4>
      <div className="mt-2">
        <Textarea
          required={currentInvoice?.invoice_type === "additional_invoice"}
          name="remarks"
          placeholder={intl.formatMessage({
            id: "general.typeHere",
            defaultMessage: "Type here...",
          })}
          rows={3}
          className="text-body bg-white"
        />
        {currentInvoice?.invoice_type === "additional_invoice" && (
          <div className="mt-2">
            <Alert variant="warning" iconClass="d-none">
              <FormattedMessage
                id="invoices.remarksAlertDesc"
                defaultMessage="This is an additional invoice, please ensure your shipper is aware of and understands the nature of this additinonal document."
              />
            </Alert>
          </div>
        )}
      </div>
    </div>
  );
}

export default InvoiceFormRemarks;
